import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RouteFilterationComponent } from './component/route-filteration/route-filteration.component';
import { RouteListingComponent } from './component/route-listing/route-listing.component';
import { RouteDetailsComponent } from './component/route-details/route-details.component';
import { MainComponent } from './main.component';
import { SearchFilterComponent } from './component/search-filter/search-filter.component';


const routes: Routes = [
  {
    path: '', component: MainComponent
  },
  {
    path: 'filteration', component: RouteFilterationComponent
  },
  {
    path: 'search', component: SearchFilterComponent
  },
  {
    path: 'listing', component: RouteListingComponent
  },
  {
    path: 'route-detail', component: RouteDetailsComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ItineriesRoutingModule { }
